export default __webpack_public_path__ + "static/media/registry.1024c892.svg";